<script>
//	import { createEventDispatcher } from 'svelte';
  import { site } from './store.js'

  export let index
  export let img
  export let name
  export let logo
  export let logo_width
  export let intro
  export let description
  export let href
  export let open

//	const dispatch = createEventDispatcher();

  $: opened = $site.division.list[index].open

  function show(ev){
    site.update(s => {
      (s.division.list.find(i => i.open == true) || {} ).open = false
      s.division.list[index].open = true
      s.division.background = `${img}`
      return s
    })
  }

  function hide(){
    site.update(s => {
      s.division.list[index].open = false
      s.division.background = `${s.division.background_default}`
      return s
    })
  }

  function toggle(){
    opened ? hide() : show()
  }

</script>

<div class="divisions-item">
  {#if opened}
    <div class="divisions-item-t more-info {open ? 'opened' : ''}">
      <div class="divisions-item-tc">
        <div class="wrap-info">
          <h3><img src={ logo } alt={ name } style="width: { logo_width };"></h3>
          <p>{ description }</p>
          <a href={ href } class="read-more">VISIT { name.toUpperCase() }<span class="screen-reader-text">{ name .toUpperCase() }</span></a>
        </div>																
      </div>
    </div>
    <button type="button" on:click={ toggle }>Close</button>
  {:else}
    <div class="divisions-item-t wow fadeInUp" data-wow-delay="0.15s" data-wow-duration="1.4s" style="visibility: visible; animation-duration: 1.4s; animation-delay: 0.15s; animation-name: fadeInUp;">
      <div class="divisions-item-tc">
        <div class="wrap">
          <h3>{ name }</h3>
          <p>{ intro }</p>
        </div>
        <button type="button" on:click={ toggle } class="more-link" title="Learn more">+<span class="screen-reader-text">open</span></button>								
      </div>
    </div>
  {/if}
</div>

